export const URL = {
    ENV_BASE_API: `https://${process.env.REACT_APP_API_URL}`,
    MOCK_BASE_API: 'http://localhost:8080',
}